package br.com.vvrefeicoes.portal.domain.repository

import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.model.RhSheetKind
import br.com.vvrefeicoes.portal.domain.model.RhSheetLoad
import br.com.vvrefeicoes.portal.domain.model.RhUnitPreview

interface RhSheetRepository {
    /** Devolve as linhas (mapas chaveados pelo header) ou `null` se ainda não houver dados no período. */
    suspend fun load(
        kind: RhSheetKind,
        period: MonthPeriod,
    ): RhSheetLoad?

    /**
     * Grava as linhas do período. [unitByDepartment] leva a unidade conferida para cada departamento
     * da planilha (`null` = sem unidade); departamentos fora do mapa seguem a última conferência.
     */
    suspend fun save(
        kind: RhSheetKind,
        period: MonthPeriod,
        rows: List<Map<String, String>>,
        unitByDepartment: Map<String, String?> = emptyMap(),
    )

    /** Unidades cadastradas e a unidade sugerida para cada departamento da planilha. */
    suspend fun previewUnits(departments: List<String>): RhUnitPreview

    /** Exclui todos os dados da aba no período. */
    suspend fun delete(
        kind: RhSheetKind,
        period: MonthPeriod,
    )
}
